import React from "react";
import { view } from "../../lib/vvm";
import Input from "../Input/Input";
import Button, { ButtonDesign, ButtonSize } from "../Button/Button";
import styles from "./TypeTagsInput.module.css";
import { formatTypeTag } from "../../utils/typeTags";
import { TypeTagsInputViewModel } from "./TypeTagsInputViewModel";

export interface TypeTagsInputProps {
  tags: string[];
  suggestions: string[];
  inputValue: string;
  onInputValueChange: (value: string) => void;
  onAddTags: (tags: string[]) => void;
  onRemoveTag: (tag: string) => void;
  placeholder?: string;
  disabled?: boolean;
  datalistId: string;
}

export const TypeTagsInput: React.FC<TypeTagsInputProps> = view(
  TypeTagsInputViewModel,
)<TypeTagsInputProps>(({
  viewModel: {
    tags,
    suggestions,
    inputValue,
    placeholder,
    disabled,
    datalistId,
    filteredSuggestions,
    onInputChange,
    onInputKeyDown,
    commitInput,
    onAddButtonClick,
    onTagRemove,
    onSuggestionMouseDown,
  },
}) => {
  return (
    <div className={styles.root}>
      <div className={styles.tags}>
        {tags.length > 0 ? (
          tags.map((tag) => (
            <button
              key={tag}
              type="button"
              className={styles.tag}
              onClick={() => onTagRemove(tag)}
              title="Убрать тег"
              disabled={disabled}
            >
              <span>{formatTypeTag(tag)}</span>
              <span className={styles.removeMark}>×</span>
            </button>
          ))
        ) : (
          <span className={styles.empty}>Теги не добавлены</span>
        )}
      </div>

      <div className={styles.inputRow}>
        <Input
          value={inputValue}
          onChange={onInputChange}
          onKeyDown={onInputKeyDown}
          onBlur={commitInput}
          placeholder={placeholder}
          list={datalistId}
          disabled={disabled}
        />
        <Button
          design={ButtonDesign.basic}
          size={ButtonSize.tiny}
          onClick={onAddButtonClick}
          disabled={disabled}
        >
          добавить
        </Button>
      </div>

      <datalist id={datalistId}>
        {suggestions.map((suggestion) => (
          <option key={suggestion} value={formatTypeTag(suggestion)} />
        ))}
      </datalist>

      {filteredSuggestions.length > 0 && (
        <div className={styles.suggestions}>
          {filteredSuggestions.map((suggestion) => (
            <button
              key={suggestion}
              type="button"
              className={styles.suggestion}
              onMouseDown={(event) => onSuggestionMouseDown(event, suggestion)}
              disabled={disabled}
            >
              {formatTypeTag(suggestion)}
            </button>
          ))}
        </div>
      )}
    </div>
  );
});
